import React, { useState, useEffect } from 'react';
import { Button, Box, ButtonGroup, Typography, Link, List, ListItem, ListItemText, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import classService from '../../services/class_service';

const ManagementKelasPage = () => {
  const navigate = useNavigate();
  const [kelas, setKelas] = useState([]);

  // Menggunakan Redux untuk saving token
  // Token ntar dulu
  // const token = useSelector((state) => state.token);

  const fetchKelas = async () => {
    try {
      const response = await classService.getAllClass()
      if (response.data) setKelas(response.data)
    } catch (error) {
      console.error(error);
    }
  };

  const refresh = () => window.location.reload(true)

  const handleDelete = async (id) => {
    try {
      const response = await classService.deleteOneClass(id);
      console.log(response);
      refresh()
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    fetchKelas()
  }, [])

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Kelas" />
      </Box>
      <Box sx={{ fontFamily: 'inherit' }}>
        <Button sx={{ left: 280, boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white', mt: 2, mb: 2 }} onClick={() => navigate('/dashboard/management/kelas/add')}>
          <Typography variant="subtitle1" sx={{ fontFamily: 'Titillium Web', fontWeight: 'bold', fontSize: 14 }}>
            + Tambah Kelas
          </Typography>
        </Button>

        <Box sx={{ marginLeft: '280px', marginRight: '10px' }} display="flex" justifyContent="space-between" mb={2}>
          <TableContainer component={Paper} sx={{ fontFamily: 'Titillium Web', maxHeight: '600px' }}>
            <Table aria-label='Daftar Kelas' stickyHeader>
              <TableHead>
                {/* <TableRow>Daftar Kelas</TableRow> */}
                <TableRow>
                  <TableCell>ID Kelas</TableCell>
                  <TableCell>Nama</TableCell>
                  <TableCell>Tanggal</TableCell>
                  <TableCell>Time Start</TableCell>
                  <TableCell>Time End</TableCell>
                  <TableCell>Ruangan</TableCell>
                  <TableCell>Jenis Kelas</TableCell>
                  <TableCell>Slot</TableCell>
                  <TableCell>Calories</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  kelas.map(row => {
                    console.log(row);
                    return (
                      <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{moment(row.datetime_start).format("ll")}</TableCell>
                        <TableCell>{moment(row.datetime_start).format("LT")}</TableCell>
                        <TableCell>{moment(row.datetime_end).format("LT")}</TableCell>
                        <TableCell>{row.location}</TableCell>
                        <TableCell>{row.class_type_id}</TableCell>
                        <TableCell>{row.capacity}</TableCell>
                        <TableCell>{row.calories}</TableCell>
                        <TableCell>
                          <ButtonGroup variant="outlined" aria-label="outlined button group">
                            {/* <Button variant="contained" color="success">Info</Button> */}
                            <Button variant="contained" color="warning" onClick={() => navigate(`/dashboard/management/kelas/update/${row.id}`)}>Edit</Button>
                            {/* <Link className='text-decoration-none btn btn-sm btn-success' to={'/dashboard/management/kelas/update/${row.id}'}>Edit</Link> */}
                            <Button variant="contained" color="error" onClick={() => handleDelete(row.id)}>Delete</Button>
                          </ButtonGroup>
                        </TableCell>

                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

      </Box>
    </>
  );
};

export default ManagementKelasPage;